import { render } from "./AuthPage.vue?vue&type=template&id=25c1847a&ts=true"
import script from "./AuthPage.vue?vue&type=script&lang=ts"
export * from "./AuthPage.vue?vue&type=script&lang=ts"

import "./AuthPage.vue?vue&type=style&index=0&id=25c1847a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__